module.exports = __webpack_public_path__ + "img/name-aula.f8ca51b4.svg";